import get from 'lodash.get';

const getMoneyBackGuarantee = (rootState) =>
  get(rootState, 'user.partnerData.properties.moneyBackGuarantee', 0);

export default getMoneyBackGuarantee;
